import React, { useRef, useState, useEffect } from 'react';
import Image from 'next/image';

import { CFColorTokenProp } from '../../../theme/tokens/contentful-color';

import {
  GetStartedInput,
  GetStartedButton,
  GetStartedIconBtn,
  GetStartedWrapper
} from './GetStartedWidget.styles';

import { WidgetProps, DEFAULT_BUTTON_TEXT } from '../shared';

import blackMiniArrow from '@/images/mini-arrow-black.svg';
import whiteMiniArrow from '@/images/mini-arrow-white.svg';
import blackArrow from '@/images/arrow-black.svg';
import whiteArrow from '@/images/arrow-white.svg';

export interface GetStartedWidgetProps extends WidgetProps {
  onStartClick?: () => void;
}

export function GetStartedWidget({
  buttonColor = 'ginger',
  buttonHoverColor = 'green',
  buttonText = DEFAULT_BUTTON_TEXT,
  buttonContent,
  isScrolled = false,
  onStartClick,
  inputProps
}: GetStartedWidgetProps) {
  const [isStartClicked, setIsStartClicked] = useState(false);
  const [imgSrc, setImgSrc] = useState('');

  const getStartInputRef = useRef<any>();
  const tabIndex = isStartClicked ? 0 : -1;

  useEffect(() => {
    const useLightArrow = ['blackberry', 'sweetmint'].includes(
      buttonColor as string
    );
    const arrow = useLightArrow ? whiteArrow : blackArrow;
    const miniArrow = useLightArrow ? whiteMiniArrow : blackMiniArrow;
    setImgSrc(isScrolled ? miniArrow : arrow);
  }, [buttonColor]);

  return isStartClicked ? (
    <GetStartedWrapper
      id="flex-wrapper"
      flexDirection="column"
      justifyContent="center"
    >
      <GetStartedInput
        ref={getStartInputRef}
        tabIndex={tabIndex}
        isScrolled={isScrolled}
        {...inputProps}
      />
      <GetStartedIconBtn
        type="submit"
        cfButtonColor={buttonColor as CFColorTokenProp}
        cfButtonHoverColor={buttonHoverColor as CFColorTokenProp}
        isScrolled={isScrolled}
        aria-label="Get started"
        data-testid="get-started-button"
      >
        <Image src={imgSrc} alt="Submit button with right arrow icon" />
      </GetStartedIconBtn>
    </GetStartedWrapper>
  ) : (
    <GetStartedButton
      type="submit"
      cfButtonColor={buttonColor as CFColorTokenProp}
      cfButtonHoverColor={buttonHoverColor as CFColorTokenProp}
      isScrolled={isScrolled}
      onClick={(e) => {
        e.preventDefault();
        setIsStartClicked(true);
        onStartClick && onStartClick();
        return getStartInputRef?.current?.element?.focus();
      }}
      aria-label="Get started"
      data-testid="get-started-button"
    >
      {buttonContent || buttonText}
    </GetStartedButton>
  );
}
